// Converts ISO 8601 UTC timestamp strings (as serialised by the API) into Date objects.
// API responses can be well over a hundred megabytes for large projects, and JSON.parse with a reviver is roughly
// five times slower than a plain parse followed by a walk over the parsed tree, so the walk is used for parsing.
const isoDateLength = '2024-01-31T12:34:56.789Z'.length;
const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

export function looksLikeIsoDate(value: string): boolean {
  return value.length === isoDateLength && value[10] === 'T' && value[23] === 'Z' && dateRegex.test(value);
}

// JSON reviver equivalent of parseJsonWithDates, for small payloads and backwards compatibility
export function dateParser(_key: unknown, value: unknown): unknown {
  if (typeof value === 'string' && looksLikeIsoDate(value)) {
    return new Date(value);
  }
  return value;
}

export function parseJsonWithDates(text: string): unknown {
  return reviveDates(JSON.parse(text));
}

// Replaces every timestamp string in the parsed JSON tree with a Date, in place
export function reviveDates(value: unknown): unknown {
  if (typeof value === 'string') {
    return looksLikeIsoDate(value) ? new Date(value) : value;
  }
  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      if (typeof item === 'string') {
        if (looksLikeIsoDate(item)) {
          value[index] = new Date(item);
        }
      } else if (item !== null && typeof item === 'object') {
        reviveDates(item);
      }
    });
    return value;
  }
  if (value !== null && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    Object.keys(record).forEach(key => {
      const item = record[key];
      if (typeof item === 'string') {
        if (looksLikeIsoDate(item)) {
          record[key] = new Date(item);
        }
      } else if (item !== null && typeof item === 'object') {
        reviveDates(item);
      }
    });
    return value;
  }
  return value;
}
